<template>
    <div class="content">
        <div class="circular">
            <p id="num_fa_text">0</p>
            <main>
                <h3>发</h3>
                <div class="beam"></div>
                <div class="bg rotateX">
                    <div class="rotateZ"></div>
                </div>
            </main>
        </div>
        <div class="list">
            <div class="list-scorll">
                <vue-seamless-scroll v-if="dataList.length>0" class="seamless-warp" :data="dataList" :class-option="defaultOption">
                    <ul v-for="(item,index) in dataList">
                        <li>
                            <div class="item-both">
                                <span class="item-name">{{item.name}}</span>
                                <span class="item-value">{{item.value}}</span>
                            </div>
                            <div class="item-line">
                                <div class="item-color" :style="{'background-image':'-webkit-gradient(linear,left top,right top,color-stop(1%,rgba(1,77,165,0)),to('+dataList[index].color+'))','width':dataList[index].percent+'%'}"></div>
                                
                            </div>
                            <div class="ring-position">
                                <div class="ring" :style="{'background':'-webkit-radial-gradient(circle closest-side,rgba(1,77,165,0)90%,'+dataList[index].colorChange+'10%)','margin-left':dataList[index].percent+'%'}">
                                    <div class="item-graph-tag" :style="{'background-color':dataList[index].colorChange}">
                                        <div class="bg-graph" :style="{'background-color':dataList[index].color}"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </vue-seamless-scroll>
            </div>
        </div>
        <div class="path" v-if="pulse[0].show" key="img1"><img :src="img(require('@/assets/images/GIF/faPath1.gif'))"></div>
        <div class="path" v-if="pulse[1].show" key="img2"><img :src="img(require('@/assets/images/GIF/faPath2.gif'))"></div>
        <div class="path" v-if="pulse[2].show" key="img3"><img :src="img(require('@/assets/images/GIF/faPath3.gif'))"></div>
        <div class="path" v-if="pulse[3].show" key="img4"><img :src="img(require('@/assets/images/GIF/faPath4.gif'))"></div>
        <div class="path" v-if="pulse[4].show" key="img5"><img :src="img(require('@/assets/images/GIF/faPath5.gif'))"></div>
    </div>
</template>

<script>
    import vueSeamlessScroll from 'vue-seamless-scroll';
    import {numAnimation} from '../../assets/js/common'

    export default {
        name: "bianModule",
        components: {
            vueSeamlessScroll,
        },
        data() {
            return {
                dataList: [],
                amountFa: 0,
                colorChange: ['rgb(38,97,114)','rgb(78,44,48)','rgb(0,119,154)','rgb(87,104,93)','rgb(72,74,145)'],
                color: ['rgb(52,228,164)','rgb(183,68,7)','rgb(0,203,241)','rgb(225,194,23)','rgb(183,106,218)'],
                update: false,
                pulse: [
                    {show: false, dur: 1400},
                    {show: false, dur: 1500},
                    {show: false, dur: 1700},
                    {show: false, dur: 1900},
                    {show: false, dur: 2100}
                ],
                during: 2100,
                timer: null
            }
        },
        mounted(){
            this.getData();
            // this.setUpdate();
            this.timer =setInterval(() => {
                this.getData();
            }, 1000*60*15);
        },
        watch: {
            amountFa: function (n, o) {
                let _that = this;
                if (n !== o && n !== 0) {
                    setTimeout(() => {
                        _that.pulse.forEach((item)=>{
                            item.show = false;
                        });
                        numAnimation("num_fa_text", {
                            time: 1500,
                            num: n,
                            regulator: 100,
                            start: o ? o : 0,
                        });
                    }, _that.during);
                }
            },
            dataList: function (n, o) {
                let _that = this;
                let changeArr = [];
                // 比对新老数据,监测到不一样的数据，将索引插入到队列中
                n.forEach(function (item,index,arr) {
                    if (o[index]){
                        if (item.value!==o[index].value) {
                            _that.pulse[index].show = true;
                        }
                    } else if (index < 5) {
                        _that.pulse[index].show = true;
                        _that.during = _that.pulse[index].dur;
                    }
                });
            }
        },
        computed: {
            defaultOption() {
                return {
                    step: 0.8, // 数值越大速度滚动越快
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
                    limitMoveNum: 6
                }
            },
            img(){
                return function (path) {
                    return path + '?' + new Date().getTime();
                }
            },
        },
        methods: {
            setUpdate(){
                this.update = false;
                this.$nextTick(() => {
                    this.update = true;
                })
            },
            getData(){
                this.axios.get('/bigscreen/bianfacenter.json').then(res => {
                    var list = res.data.data;
                    this.amountFa = list.faCount; 
                });

                this.axios.get('/bigscreen/qudaoqianfa.json').then(res => {
                    this.dataList = [];
                    var data = res.data;
                    for(let i = 0; i<data.data.length; i++){
                        let obj = {
                            name:'',
                            value:0,
                            color: 'rgb(52,228,164)',
                            colorChange: 'rgb(38,97,114)',
                            percent: 0,
                        };
                        if(data.data[i].count !== 0){
                            obj.name = data.data[i].name;
                            obj.value = data.data[i].count;
                            this.dataList.push(obj);
                        }
                    }

                    for(var i=0;i<this.dataList.length;i++){
                        for(var j=0;j<this.color.length;j++){
                            if(i % 5 == j){
                                this.dataList[i].color = this.color[j];
                            }
                        }
                        for(var k=0;k<this.colorChange.length;k++){
                            if(i % 5 == k){
                                this.dataList[i].colorChange = this.colorChange[k];
                            }
                        }
                        
                    }
                    this.dataList.sort(function (a, b) {
                        return b.value - a.value
                    })
                    this.getChangeData(this.dataList);
                })
            },
            getChangeData(dataList){
                var sum=0;
                for(var i=0;i<dataList.length;i++){
                //    sum += dataList[i].value;
                    // 取所有数的最大值
                    if(sum<=dataList[i].value){
                        sum = dataList[i].value;
                    }
                }
                for(var i=0;i<dataList.length;i++){
                    this.dataList[i].percent = 100*dataList[i].value/sum;
                }
                
            },
        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    }
</script>

<style scoped>
    .content{
        font-size: 25px;
        position: relative;
    }
    .content .path{
        position: absolute;
        top: -123px;
        left: -56px;
    }
    .circular{
        width: 264px;
        height: 264px;
        position: absolute;
        left: 50px;
        bottom: 0;
    }
    .circular main{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .circular .bg{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .circular .bg.rotateX{
        transform: rotateX(60deg);
    }
    .circular .rotateZ{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url("../../assets/images/circle.png") center center no-repeat;
        background-size: 100% 100%;
        transform: rotateZ(60deg);
        animation: circular-bg 5s linear 0s infinite normal;
    }
    .circular h3{
        font-size: 48px;
    }
    .circular p{
        font-size: 50px;
        color: #eacb42;
        font-weight: bold;
        position: absolute;
        left: 30px;
        width: 200px;
        text-align: center;
    }
    .beam{
        width: 240px;
        height: 129px;
        position: absolute;
        background: url("../../assets/images/beam.png")center center no-repeat;
        background-size: 100% 100%;
        bottom: 110px;
        left: 10px;
    }
    @keyframes circular-bg {
        0% {transform: rotateZ(60deg);}
        100% {transform: rotateZ(420deg)}
    }
    .content .list {
        position:absolute;
        width: 700px;
        height: 500px;
        line-height: 67px;
        margin-top: -50px;
        margin-left: -10px;
        overflow-y: hidden; 
        
    }
    .content .list .list-scorll { 
        height: 370px;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 0 !important;
          }
    }
    .content .list .list-scorll::-webkit-scrollbar {
        display: none; /* 隐藏滚动条，但依旧具备可以滚动的功能 */
    }
    .content .list .list-scorll .seamless-warp {
        height: 370px;
    }
    .content .list ul li {
        height: 73px;
        
    }
    .content .list .item-both {
        margin-left: 35px;
        width: 565px;
    }
    .content .list .item-both .item-value {
        float: right;
        color: rgb(57,253,249);
        font-size: 32px;
    }
    .content .list .item-line {
        width: 600px;
        height: 6px;
        background-color: rgb(22,59,111);
        margin-top: -8px;
        margin-left: 10px;
        
    }
    .content .list .item-line .item-color {
        
        height: 100%;
        z-index: 2;
        position:relative;
        
    }
    .item-graph-tag {
        border-radius: 100%;
        width:18px;
        height:18px;
        

        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .bg-graph {
        border-radius: 100%;
        width:8px;
        height:8px;
        
        
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .ring {
        border-radius: 50%;
        width:25px;
        height:25px;
        
        position: relative;
    }
    .ring-position {
        margin-top: -15px;
        margin-left: 0px;
        z-index:1;
        width: 600px;
        position:relative;
    }
</style>
